import * as React from 'react';

export type ModalState = [boolean, { open: () => void; close: () => void }];

export function useModalState(initialState?: boolean): ModalState {
  const [modalState, setModalState] = React.useState(initialState ?? false);

  const actions = React.useMemo(
    () => ({
      open: () => setModalState(true),
      close: () => setModalState(false),
    }),
    [setModalState],
  );

  return [modalState, actions];
}
